import { Component, OnInit, EventEmitter } from '@angular/core';
//import { version } from '../../../package.json';
import { Router } from '@angular/router';
import { Constants } from '../util/constants';
import { User } from '../models/user.model';
import { LocalStorage } from '../util/localstorage.service';
import { version } from '../../../package.json';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
	styleUrls: ['./header.component.scss'],
	inputs: ['optionType'],
	outputs: ['showHideSideBar']
})
export class HeaderComponent implements OnInit {

	//public projectName: string = environment.appname
	public appVersion: string = version
	public serviceVersion: string = ""
	public optionType: any = Constants.CUSTOMER_REPORTS_HEADER_OPTION
	public isToggleMenu: boolean = false
	public isShowSearch: boolean = true
	public loggedInUser: any
	public isSuperUser: boolean = false
	public isUser: boolean = false
	public loggedUser: User

	public showHideSideBar = new EventEmitter<any>()

	constructor(private router: Router) { }

	ngOnInit() {
		this.serviceVersion   = JSON.parse(localStorage.getItem(LocalStorage.SERVICE_VERSION)) as string;
		this.loggedUser   = JSON.parse(localStorage.getItem(LocalStorage.LOGGED_USER)) as User;
		if ((this.loggedUser != null) && (this.loggedUser != undefined)) {
			this.loggedInUser = {
				firstName: this.loggedUser.FirstName,
				lastName: this.loggedUser.LastName
			}

			// check whther the user is Super User
			if (this.loggedUser.UserRoleID == Constants.UserRoleID.SuperUser){
				this.isSuperUser = true
				this.isUser = false
			} else if(this.loggedUser.UserRoleID == Constants.UserRoleID.AdminUser){
				this.isSuperUser = false
				this.isUser = false
			} else if(this.loggedUser.UserRoleID == Constants.UserRoleID.User){
				this.isUser = true
			}

		} else {
			//Don't know the user, send to login.
			this.router.navigateByUrl('');
		}


	}

	public showToggleMenu() {

	}

	public TBBO2TherapyReportBtn() {
		this.router.navigateByUrl('tbbo2therapyreport');
	}

	public TBBO2RecoveryTimeReportBtn() {
		this.router.navigateByUrl('tbbo2recoverytimereport');
	}

	public EditProfileBtn() {
		this.router.navigateByUrl('editprofile');
	}
	public ChangePasswordBtn() {
		this.router.navigateByUrl('changepassword');
	}

  public RequestDeleteProfileBtn() {
    this.router.navigateByUrl('requestdeleteprofile');
  }

	public ManageUsersBtn() {
		this.router.navigateByUrl('manageusers');
	}

	public ManageDeleteRequestsBtn() {
		this.router.navigateByUrl('managedeleterequests');
	}

	public ManageClinicsBtn() {
		this.router.navigateByUrl('manageclinics');
	}

	public ManageMachinesBtn() {
		this.router.navigateByUrl('managemachines');
	}

	public ManagePatientsBtn() {
		this.router.navigateByUrl('managepatients');
	}

	public ManagePasscodeBtn() {
		this.router.navigateByUrl('managepasscode');
	}

	public showHideSlideBar() {
		console.log('[showHideSlideBar]');
		this.showHideSideBar.emit()
	}

	public signOutBtnClickEvent() {
		localStorage.clear();
		this.router.navigateByUrl('')
	}

	public ImportDataBtn(){
		this.router.navigateByUrl('importdata');
	}

	public ServiceCodesScanBtn() {
		this.router.navigateByUrl('servicecodesscan');
	}
}
